import { ReactNode } from 'react'
import { Breakpoint } from '@mui/system'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type ModalTitleType = string | ReactNode

type ModalDataType = {
  hasCancel?: boolean
  width?: Breakpoint | false
  bgColor?: string
  noPadding?: boolean
}

type State = {
  isOpen: boolean
  title?: string | ReactNode
  children?: ReactNode
  data?: ModalDataType
  action?: ReactNode
  closeOnOverlayClick?: boolean
}

type Actions = {
  setTitle: (title: ModalTitleType) => void
  setChildren: (children: ReactNode) => void
  setAction: (action: ReactNode) => void
  setOpen: (isOpen: boolean) => void
  closeModal: () => void
  setData: (data: ModalDataType) => void
  setCloseOnOverlayClick: (closeOnOverlayClick: boolean) => void
  setModal: (modal: State) => void
}

export const useModalManager = create<State & Actions>()(
  devtools((set) => ({
    isOpen: false,
    children: null,
    data: undefined,
    action: null,
    setOpen: (isOpen) => {
      set({ isOpen, children: null, title: null, action: null })
    },
    setTitle: (title) => set({ title }),
    setChildren: (children) => set({ children }),
    setData: (data) => set({ data }),
    setAction: (action) => set({ action }),
    closeModal: () =>
      set({ isOpen: false, children: undefined, title: undefined }),
    setCloseOnOverlayClick: (closeOnOverlayClick) =>
      set({ closeOnOverlayClick }),
    setModal: (modal) => set(modal),
  })),
)
